module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gear","short_name":"Gear","start_url":"/","background_color":"#ffffff","theme_color":"#222222","display":"minimal-ui","icon":"src/icons/crossed-swords.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f2dadf97f7bed5ef642fa29a49e4f993"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
